import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _SubMacroProcess } from '../../../../../core/services/dataBean/EntityCatalog';
import { _ProjectDataDocumentsType } from '../../../../../core/services/dataBean/EntityCatalogVdos';


interface Props {
    idProject?: number;
    documentsTable?: any;
    idSelector: any;
    onChange: (value: string | null) => void;
    label?: string;
}

export const ProjectDataDocumentsType = ({ idSelector, idProject, documentsTable, onChange, label }: Props) => {

    const projectdata = useDataBean(_ProjectDataDocumentsType)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector)
        }
    }, [])


    useEffect(() => {
        getLista();
    }, [idProject, documentsTable])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        const value = e.target.value === "null" ? null : e.target.value;
        setID(value);
    };

    const getLista = () => {
        projectdata.instance.getProjectDataDocumentsType(idProject, documentsTable).then(
            (resp) => {
                setLista(resp)
            }
        )
    }

    return (
        <>
            <label>{label ?? "Tipo Documento"}</label>
            <select className="form-select" value={id ?? "null"} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}